import { arrRemove } from '../../../project/src/constant/utils'

export default {
  methods: {
    clickName: async function(item) {
      // const id = item._id
      // const name = item['姓名']
      this.currentRow = item
      // app.root.$refs.radishDetailTab.addTab({ id: id, title: name })
      window.open(`${window.frontend}/#/radish-detail-blank/${item._id}`, '_blank')
    },
    clickCompany: function(companyName) {
      app.root.onPull()
      app.root.$refs.drawer.search({
        type: '公司',
        keywords: companyName,
      })
    },
    showTargetCompany: function() {
      app.root.$refs.selectCompany.open(this.searchData['目标公司'] || [], companies => {
        // console.log(companies)
        this.searchData['目标公司'] = companies
        this.handleSearch()
      })
      // app.root.$refs.targetCompany.show({
      //   defaultCompanies: this.searchData['目标公司'] || [],
      //   onConfirm: companies => {
      //     // console.log(companies)
      //     this.searchData['目标公司'] = companies
      //     this.handleSearch()
      //   },
      // })
    },

    showFiles: async function(row) {
      if (row['附件'] && row['附件'] > 0) {
        const res = await app.service('radish').listAttachment({ rid: row._id })
        if (res.status == 'success') {
          this.popperVisible = true
          this.popperContent = 'files'
          this.files = res.data
          this.popperTarget = `附件${row._id}`
        } else {
          this.$message.error(res.msg)
        }
      } else {
        this.$message.info('没有附件')
      }
    },

    showAction: async function(row) {
      const res = await app.service('radish').simpleFetch({ _id: row._id })
      if (res.status == 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg == 'nothave') {
        this.$message.warning('人选不存在')
        this.loadData()
        return
      }
      this.popperVisible = true
      this.popperContent = 'action'
      this.currentRow = row
      this.popperTarget = `操作${row._id}`
    },

    showIntoProject: async function(multi) {
      let rows
      if (typeof multi === 'object') {
        await app.service('project').saveRecords({ type: '人选加入项目', path: '条件搜索', page: '人才' })
        rows = [multi]
      } else if (multi) {
        await app.service('project').saveRecords({ type: '批量加入项目', path: '条件搜索', page: '人才' })
        rows = this.$refs.radishTable.getChecked()
      } else {
        await app.service('project').saveRecords({ type: '人选加入项目', path: '条件搜索', page: '人才' })
        rows = [this.currentRow]
      }
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
      } else if (this.defaultProject && this.defaultProject._id) {
        this.intoProject(rows)
      } else {
        app.root.$refs.radishProDialog.show(rows, 'intoProject', this.onConfirm)
      }
    },
    showRecommend: async function(multi) {
      let rows
      if (multi) {
        await app.service('project').saveRecords({ type: '批量推荐人选', path: '条件搜索', page: '人才' })
        rows = this.$refs.radishTable.getChecked()
      } else {
        await app.service('project').saveRecords({ type: '推荐人选到项目', path: '条件搜索', page: '人才' })
        rows = [this.currentRow]
      }
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
      } else {
        for (const row of rows) {
          if (!row['手机']) {
            this.$alert('cc候选人不能推荐', { showClose: false })
            return
          }
        }
        if (this.defaultProject && this.defaultProject._id) {
          this.recommend(rows)
        } else {
          app.root.$refs.radishProDialog.show(rows, 'recommend')
        }
      }
    },
    intoProject: async function(rows) {
      const { onkeyMatchMode } = this
      const dt = []
      rows.forEach(row => {
        dt.push({ rid: row._id, pid: this.pid, onkeyMatchMode })
      })
      const res = await app.service('radish').intoProject(dt)
      if (res.status == 'success') {
        this.$alert('加入成功', { showClose: false })
        this.onConfirm && this.onConfirm()
      } else {
        this.$alert(res.msg)
      }
    },
    recommend: async function(rows) {
      const names = []
      for (const row of rows) {
        const res = await app.service('radish').addRecommend({ rid: row._id, pid: this.pid })
        if (res.status == 'fail') {
          if (res.msg == '已推荐过') {
            names.push(row['姓名'])
          } else {
            console.log(res.msg)
          }
        }
      }
      if (names.length > 0) {
        let message = '已推荐过'
        const nameStr = names.join('、')
        message = `${message}[${nameStr}]到[${this.defaultProject.label}]`
        this.$alert(message)
      } else {
        this.$alert('推荐成功', { showClose: false })
      }
    },
    uploadCv: async function(item) {
      await app.service('project').saveRecords({ type: '上传简历', path: '条件搜索', page: '人才' })
      if (item) {
        this.currentRow = item
      }
      this.attachType = '原始简历'
      this.uploadType = '原始简历'
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    uploadReport: async function() {
      await app.service('project').saveRecords({ type: '上传推荐报告', path: '条件搜索', page: '人才' })
      this.attachType = '推荐报告'
      this.uploadType = '推荐报告'
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    uploadSuccess: async function(response, file, fileList) {
      const attach = response.map(res => {
        const dt = {
          fileId: res._id,
          uploader: res.uploader,
          originalname: res.originalname,
          src: res.src,
          md5: res.md5,
        }
        dt.rid = this.currentRow._id
        dt.type = this.attachType
        return dt
      })
      if (attach.length > 0) {
        const aRes = await app.service('radish').addAttachment(attach)
        if (aRes.status == 'success') {
          this.$message.success({ duration: 500, message: '上传成功' })
          await this.loadOne(this.currentRow._id)
        } else {
          console.log(aRes)
        }
      } else {
        this.$message.info('未添加附件')
      }
      this.$refs.UploadDialog.visible()
      this.$refs.UploadDialog.clean()
    },
    addToFavorite: async function() {
      await app.service('project').saveRecords({ type: '批量加入收藏夹', path: '条件搜索', page: '人才' })
      const rows = this.$refs.radishTable.getChecked()
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
      } else {
        app.root.$refs.favDialog.show(rows)
      }
    },
    outFavorite: async function() {
      await app.service('project').saveRecords({ type: '批量移出收藏夹', path: '条件搜索', page: '人才' })
      const rows = this.$refs.radishTable.getChecked()
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
      } else {
        const delids = rows.map(r => r._id)
        const dt = { _id: this.fav._id, delRids: delids }
        const res = await app.service('radish').modifyFavorite(dt)
        if (res.status == 'success') {
          this.radishes = this.radishes.filter(r => !delids.includes(r._id))
          this.$message({
            type: 'success',
            message: '移出成功',
          })
        } else {
          this.$message.error(res.msg)
        }
      }
    },
    saveCondition: function() {
      if (
        Object.keys(this.searchData).length < 2 &&
        this.searchData['工作年限'][0] == 0 &&
        this.searchData['工作年限'][1] == 30
      ) {
        this.$message.warning('无搜索条件')
      } else {
        this.$refs.conditionDialog.show(this.searchData)
      }
    },
    del: async function() {
      await app.service('project').saveRecords({ type: '批量删除人选', path: '条件搜索', page: '人才' })
      const rows = this.$refs.radishTable.getChecked()
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
      } else {
        for (const row of rows) {
          if (row['手机']) {
            this.$alert('只能删除cc候选人', { showClose: false })
            return
          }
        }
        for (const row of rows) {
          const res = await app.service('radish').deleteCc({ _id: row._id })
          if (res.status == 'success') {
            await app.service('radish').deleteRelations({ rid: row._id })
          } else {
            console.log(res.msg)
          }
        }
        this.$message.success({ duration: 500, message: '删除成功' })
        this.loadData()
      }
    },
    genRepo: async function() {
      await app.service('project').saveRecords({ type: '生成推荐报告', path: '条件搜索', page: '人才' })
      app.root.$refs.reportMaker.init({ radish: this.currentRow.rid || this.currentRow._id })
    },
    editOneField: async function(params) {
      const { item, head, value } = params
      const res = await app.service('radish').simpleFetch({ _id: item._id })
      if (res.status == 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg == 'nothave') {
        this.$message.warning('人选不存在')
        this.loadData()
        return
      }
      const data = {}
      const label = head.field || head.label
      data[label] = value
      const result = await app.service('radish').modifyById({ _id: item._id, data: data })
      if (result.status == 'success') {
        this.$message.success({ duration: 500, message: '修改成功' })
      } else {
        this.$message.error(result.msg)
      }
    },
    leaveForecast: async function(item) {
      if (item['公司']) {
        const res = await app.service('radish').leaveForecast(item)
        if (res.status == 'success' && res.data.length > 0) {
          this.bulletins = res.data
          this.popperVisible = true
          this.popperContent = 'bulletin'
          this.currentRow = item
          this.popperTarget = `离职意愿度${item._id}`
          this.loadOne(item._id)
        } else {
          this.$message.info('无相应公告')
        }
      } else {
        this.$message.info('人选无公司')
      }
    },
    showExp: async function(item) {
      const res = await app.service('radish').simpleFetch({ _id: item._id, fields: { 姓名: 1, 任职经历: 1 } })
      if (res.status == 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg == 'nothave') {
        this.$message.warning('人选不存在')
        this.loadData()
        return
      }
      if (res.data['任职经历'] && res.data['任职经历'].length > 0) {
        this.popperVisible = true
        this.popperContent = 'comExp'
        this.currentRow = res.data
        this.popperTarget = `任职经历${item._id}`
      } else {
        this.$message.info('无任职经历')
      }
    },
    getSimi: async function(item) {
      const res = await app.service('radish').simpleFetch({ _id: item._id })
      if (res.status == 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg == 'nothave') {
        this.$message.warning('人选不存在')
        this.loadData()
        return
      }
      if (item.status && item.status > 0) {
        app.root.$refs.simiDialog.show(item)
      }
    },
    showEditDialog: async function() {
      await app.service('project').saveRecords({ type: '批量修改字段内容', path: '条件搜索', page: '人才' })
      const rows = this.$refs.radishTable.getChecked()
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
        return
      }
      this.$refs.editDialog.show(this.tableHeads, rows)
    },

    showCateDialog: async function(type) {
      await app.service('project').saveRecords({ type: `批量${type}职能模块`, path: '条件搜索', page: '人才' })
      const rows = this.$refs.radishTable.getChecked()
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
        return
      }
      const ids = rows.map(r => r._id)
      this.$refs.cateDialog.show(type, this.catData, ids)
    },

    showEditDepartment: async function() {
      await app.service('project').saveRecords({ type: '批量修改部门', path: '条件搜索', page: '人才' })
      const rows = this.$refs.radishTable.getChecked()
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
        return
      }
      const ids = rows.map(r => r._id)
      this.$refs.departmentDialog.show(this.departments, ids)
    },

    loadCate: async function() {
      if (!app.categories) {
        await app.getCats()
      }
      const catData = app.categories
      if (catData && catData.length > 0) {
        this.catData = catData
        const tmp = catData.map(item => item['名称'])
        const tmphead = this.tableHeads.map(t => {
          if (t.label == '职能模块') {
            t.options = tmp
          }
          return t
        })
        this.tableHeads = tmphead
        const prem = app.user['SL权限']
        const role = app.user['角色']
        let tmp2 = []
        if (!role || (!role.includes('管理员') && !role.includes('业务助理'))) {
          if (!prem || prem.length == 0) {
            tmp2 = []
          } else {
            const catArr = prem.split(';')
            tmp2 = tmp.filter(c => catArr.includes(c))
          }
        } else {
          tmp2 = JSON.parse(JSON.stringify(tmp))
        }
        tmp2.push('空')
        this.searchFields['职能模块'].options = tmp2
        this.searchFields['期望职能'].options = tmp2.slice(0)
      }
      if (this.searchFields['行业'])
        this.searchFields['行业'].options = JSON.parse(JSON.stringify(app.industries || [])).concat('空')
      if (this.searchFields['期望行业'])
        this.searchFields['期望行业'].options = JSON.parse(JSON.stringify(app.industries || [])).concat('空')
    },
    setDefQuery: async function() {
      if (this.ids && this.ids.length > 0) {
        this.query._id = this.ids.map(v => (typeof v === 'string' ? v : v.id))
      } else {
        if (this.fav && this.fav.rids) {
          this.query._id = this.fav.rids
        } else if (this.query._id) {
          delete this.query._id
        }
        if (this.company) {
          this.query = { 公司: this.company }
          if (this.department) {
            this.query['部门'] = this.department
          }
          console.log(this.group)
          if (this.group) this.query['组别'] = this.group
        }
      }
      if (this.pid) {
        const res = await app.service('project').fetch(this.pid)
        if (res) {
          this.defaultProject = {
            _id: res._id,
            label: `${res['项目名称']}(${res['客户公司']})`,
          }
        }
      }
    },
    setDefault: async function() {
      await this.setDefQuery()
      await this.loadData()
    },
    setMode: function(mode) {
      this.searchMode = mode
      // if (mode === 'complete') this.keywords = ''
      this.$nextTick(function() {
        this.resetTableHeight()
      })
    },
    resetTableHeight: function() {
      const el = this.$refs.radishTableWapper
      el && (this.tableHeight = document.documentElement.clientHeight - el.offsetTop - 120)
    },
    setHiddenCell: function(donotLoadData) {
      const heads = localStorage[this.storageName]
      if (heads) {
        const cells = JSON.parse(heads)
        const tmp = this.tableHeads.map(h => {
          if (cells[h.label]) {
            h.hidden = cells[h.label]
          } else {
            h.hidden = false
          }
          return h
        })
        this.tableHeads = tmp
      }
      if (donotLoadData) return
      this.loadData()
    },
    setCellOrder: function() {
      const headSort = localStorage[`${this.storageName}_sort`]
      if (headSort) {
        const cellSort = JSON.parse(headSort)
        const tmp = this.tableHeads.sort((a, b) => {
          const labelA = a.label
          const labelB = b.label
          if (!cellSort[labelA] || cellSort[labelA] > cellSort[labelB]) {
            return 1
          } else {
            return -1
          }
          // if (!cellSort[labelB] || cellSort[labelA] > cellSort[labelB]) {
          //   return 1
          // } else {
          //   return -1
          // }
        })
        this.tableHeads = tmp
      }
    },
    orderCondition: function() {
      app.root.$refs.orderDialog.show({
        items: this.searchOrder,
        storageName: 'search',
        onConfirm: () => {
          if (localStorage.search_sort) {
            this.searchOrder = Object.keys(JSON.parse(localStorage.search_sort))
          }
        },
      })
    },
    async deleteAttachment({ _id }) {
      try {
        const { status, msg } = await app.service('radish').deleteAttachment({ _id })
        if (status === 'success') {
          arrRemove(this.files, file => file._id === _id)
          this.$message({ message: msg, type: 'success' })
        } else {
          this.$message.error(msg)
        }
      } catch (e) {
        console.error(e)
      }
    },
  },
}
